import { ICON_COLORS } from "./avatar-picker.constants";

export const IconColorsConicGradient = ({
  color,
}: {
  color: string | undefined;
}) => {
  return (
    <span
      className="size-4 rounded-full"
      style={{
        background:
          color ??
          `conic-gradient(${ICON_COLORS.slice(1).join(", ")}, ${ICON_COLORS[1]})`,
      }}
    />
  );
};
